import { Layout } from '@/components/Layout';
import { TagManager } from '@/components/TagManager/TagManager';
import { stage } from '@/controllers/clients/stage';
import { withCSRFToken } from '@eventbrite/csrf-double-cookie';
import { EventbriteHeader } from '@eventbrite/webapp-constants';
import { ConsentManagerScripts } from '@eventbrite/webapp-data';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';

export default function Page({ ...props }) {
  return (
    <>
      <TagManager publicUserId={props.userId} stage={props.stage} />
      <ConsentManagerScripts />
      <Layout csrfToken={props.csrfToken} stage={props.stage} pageType="emailVerify"></Layout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = withCSRFToken(
  async (context: GetServerSidePropsContext) => {
    return {
      props: {
        userId: context.req.headers[EventbriteHeader.EB_USER_ID] ?? '',
        soaToken: context.req.headers[EventbriteHeader.EB_SOA_TOKEN] ?? '',
        organizationId: context.req.headers[EventbriteHeader.EB_ORGANIZATION_ID] ?? '',
        guestId: context.req.headers[EventbriteHeader.EB_GUEST_ID] ?? '',
        correlationId: context.req.headers[EventbriteHeader.EB_CORRELATION_ID] ?? '',
        stableId: context.req.headers[EventbriteHeader.EB_STABLE_ID] ?? '',
        sessionId: context.req.headers[EventbriteHeader.EB_SESSION_ID] ?? '',
        ebHost: context.req.headers[EventbriteHeader.EB_HOST] ?? '',
        stage: stage,
      },
    };
  },
);
